import { Record as record } from 'immutable';

import { construct, resolveAll } from '../helpers/LinkMapper';
import { getDefaults, getResolvers } from '../helpers/Records';
import { WeekdayNames } from '../constants/AppConstants';

import Timeslot from './Timeslot';

const fieldSchema = {
    [WeekdayNames.MONDAY]: [ resolveAll.as(Timeslot) ],
    [WeekdayNames.TUESDAY]: [ resolveAll.as(Timeslot) ],
    [WeekdayNames.WEDNESDAY]: [ resolveAll.as(Timeslot) ],
    [WeekdayNames.THURSDAY]: [ resolveAll.as(Timeslot) ],
    [WeekdayNames.FRIDAY]: [ resolveAll.as(Timeslot) ],
    [WeekdayNames.SATURDAY]: [ resolveAll.as(Timeslot) ],
    [WeekdayNames.SUNDAY]: [ resolveAll.as(Timeslot) ]
};

export default class OpeningHours extends record(getDefaults(fieldSchema)) {
    static fromJSON (json = {}) {
        return construct(OpeningHours, json, getResolvers(fieldSchema));
    }
}



// WEBPACK FOOTER //
// ./src/records/OpeningHours.js